import axios from 'axios';

const { REACT_APP_API_URL, REACT_APP_API_PORT } = process.env;

const apiUrl = REACT_APP_API_PORT ? `${REACT_APP_API_URL}:${REACT_APP_API_PORT}` : `${REACT_APP_API_URL}`;
export const baseURL = apiUrl + '/api';

export const requestWithFullData = axios.create({
  baseURL,
});

export const request = axios.create({
  baseURL,
});

export const setAxiosToken = (token) => {
  request.defaults.headers.Authorization = `Bearer ${token}`;
  requestWithFullData.defaults.headers.Authorization = `Bearer ${token}`;
}

request.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // if (error.response.data.message === 'Token expired') {
    //   localStorage.removeItem('token');
    //   redirectToLogin();
    // }
    return Promise.reject(error)
  }
);

export const downloadFile = (filePath) => {
  return requestWithFullData
    .get(filePath, {
      responseType: 'blob',
      withCredentials: true,
    })
    .then((response) => {
      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);
      const attachment = response.headers['content-disposition'];
      const fileName = attachment.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/ig)[0].replace('filename=', '').replace(/['"]/ig, '');

      // create "a" HTML element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', fileName || 'file.pdf'); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    })
}